import React from 'react'
import style from './style.module.scss'
import { TweenMax } from 'gsap'
import instagram from '../../images/instagram.svg'
import facebook from '../../images/facebook.svg'
import twitter from '../../images/twitter.svg'


const SocialIcon = (props) => {
    let self = null;

    const onMouseEnter = () => {
        TweenMax.to(self, 0.2, {
            scale: 1.1
        })
    }

    const onMouseLeave = () => {
        TweenMax.to(self, 0.2, {
            scale: 1.0
        })
    }

    const { imgSrc, link, alt } = props
    return (
        <a ref={ref => self = ref} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} href={link} target="_blank">
            <span>
                <img className={style.socialMedia} src={imgSrc} alt={alt} />
            </span>
        </a>
    )
}

const SocialMediaIcons = (props) => {


    return (
        <div className={style.socialMediaSection}>
            <SocialIcon imgSrc={facebook} link="https://www.facebook.com/Holsumpr/" alt="FACEBOOK" />
            <SocialIcon imgSrc={instagram} link="https://www.instagram.com/holsumpuertorico/" alt="INSTAGRAM" />
            <SocialIcon imgSrc={twitter} link="https://twitter.com/hashtag/holsumpr" alt="TWITTER" />
        </div>
    )

}

export default SocialMediaIcons